import chefsMarioAndAdrianAImage from './assets/chefs-mario-and-adrian_a.jpg';
import chefsMarioAndAdrianBImage from './assets/chefs-mario-and-adrian_b.jpg';
import './OurStory.css';

const OurStory = () => {
  return (
    <section className="container grid our-story">
      <div className="our-story-description">
        <h1>Big Lime</h1>
        <h2>Mumbai</h2>
        <p>
          At Big Lime, we bring the warmth of Mediterranean kitchens to Mumbai.
          Our chefs craft vibrant plates with bold citrus notes, extra-virgin
          olive oil, and market-fresh produce sourced locally. From mezze to
          slow-simmered mains and bright desserts, every dish is prepared with
          care, meant to be shared, and paired with great conversation.
        </p>
        <p>
          Join us on Marine Drive for relaxed dining, friendly service, and
          timeless flavors with a contemporary Indian touch.
        </p>
      </div>
      <div className="our-story-chefs">
        <img src={chefsMarioAndAdrianAImage} alt="Chefs Mario and Adrian" />
        <img src={chefsMarioAndAdrianBImage} alt="Chefs Mario and Adrian" />
      </div>
    </section>
  );
};

export default OurStory;
